import { t } from 'i18next'

/** @deprecated 客室管理のみで使用すること. 通常はApprovedStatusTypeを参照 */
export const ApprovedStatus = {
  Reservation: '0',
  Checkin: '1',
  Stay: '2',
  Checkout: '3',
  Customer: '4',
}
export type ApprovedStatus = (typeof ApprovedStatus)[keyof typeof ApprovedStatus]

export const ApprovedStatusType = {
  Reservation: 0,
  Checkin: 1,
  Stay: 2,
  Checkout: 3,
  Customer: 4,
} as const
export type ApprovedStatusType = (typeof ApprovedStatusType)[keyof typeof ApprovedStatusType]

export const approvedStatusValues: Record<ApprovedStatusType, string> = {
  [ApprovedStatusType.Reservation]: t('Reservation'),
  [ApprovedStatusType.Checkin]: t('CheckIn'),
  [ApprovedStatusType.Stay]: t('Stay'),
  [ApprovedStatusType.Checkout]: t('Checkout'),
  [ApprovedStatusType.Customer]: t('Customer'),
}

export type CheckinType = {
  id: string
  approvedStatus: typeof ApprovedStatus
}
